import { useWorkbookSupplementaryLearning } from '~/@common/hooks/useWorksheetParentReport'

import { SupplementaryLearningCard } from './SupplementaryLearningCard'

type Props = {
  progressId?: number | null
}

export const WorkbookSupplementaryLearning = ({ progressId }: Props) => {
  const { data } = useWorkbookSupplementaryLearning(progressId)
  return <SupplementaryLearningCard data={data ?? []} />
}
